export const handlePrev = (sliderRef) => {
  if (!sliderRef.current) return;
  sliderRef.current.swiper.slidePrev();
};

export const handleNext = (sliderRef) => {
  if (!sliderRef.current) return;
  sliderRef.current.swiper.slideNext();
};
